module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_chapelsuns_01-53adbb77051bc688da43ab0ea5a8300c.png";